import axios, { AxiosResponse } from 'axios'

const backendDomain: string = process.env.NODE_ENV === 'development' ? 
  'http://localhost:3030'
 : 'https://esl-fresh-integration.up.railway.app'

export async function getMapping(mondayAccountId: number, accessToken: string): Promise<Mapping | undefined> {
  try {
    const res: AxiosResponse = await axios.get(`${backendDomain}/mapping/${mondayAccountId}`, {
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    })
    const mapping: Mapping | undefined = res.data
  
    return mapping
  } catch (error) {
    console.log('file: accountService.ts -> line 13 -> getMapping -> error', error)
  }
}

export async function createMapping(mapping: Mapping, accessToken: string): Promise<Mapping | undefined> {
  try {
    const res: AxiosResponse = await axios.post(`${backendDomain}/mapping`, mapping, {
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    })
    const newMapping: Mapping = res.data
    return newMapping
  } catch (error) {
    console.log('file: accountService.ts -> line 30 -> createMappingDocument -> error', error)
  }
}

export async function saveMapping(mapping: Mapping, accessToken: string): Promise<Mapping | undefined> {
  try {
    const res: AxiosResponse = await axios.put(`${backendDomain}/mapping`, mapping, {
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    })
    const updatedMapping: Mapping = res.data
    return updatedMapping
  } catch (error) {
    console.log('file: mappingService.ts -> line 33 -> saveMapping -> error', error)
  }
}

export const mappingService = {
  getMapping,
  createMapping,
  saveMapping,
}
